'use strict';

export default {
  fb: 'Facebook',
  vk: 'VKontakte'
};



// WEBPACK FOOTER //
// ./app/src/constants/social_networks.js